import Ijtimai from '../../assets/images/Ijtimai.jpg';

export default function generateSlip(data) {
  const printWindow = window.open('', '_blank');

  const htmlContent = `
    <html>
      <head>
        <title>Supplier Payment Slip - ${data.pay_id || 'Print'}</title>
        <style>
          body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; padding: 10px; color: #333; }
          .container { width: 100%; max-width: 800px; margin: auto; }
          
          /* Box Styling */
          .section-box { 
            border: 2px solid #000; 
            padding: 20px; 
            margin-bottom: 15px; 
            border-radius: 4px;
            position: relative;
          }

          .header-table { width: 100%; border-collapse: collapse; margin-bottom: 10px; }
          .logo-img { width: auto; height: 70px; margin-bottom: 2px; }
          .title-section { text-align: center; }
          
          h6 { margin: 5px 0; font-size: 18px; text-transform: uppercase; text-decoration: underline; }
          
          .copy-label { 
            position: absolute; 
            top: 10px; 
            right: 15px; 
            font-weight: bold; 
            font-style: italic; 
            background: #eee; 
            padding: 2px 10px; 
            border: 1px solid #999;
            font-size: 12px;
          }
          
          .info-table { width: 100%; border-collapse: collapse; margin-top: 10px; }
          .info-table td { padding: 10px; border-bottom: 1px solid #ddd; font-size: 13px; }
          .label { font-weight: bold; width: 20%; }
          .value { text-align: left; width: 30%; font-weight: 500; }
          
          .divider { border-top: 2px dashed #333; margin: 20px 0; position: relative; }
          .divider::after { content: "✂ Cut Here"; position: absolute; top: -12px; left: 50%; transform: translateX(-50%); background: white; padding: 0 10px; font-size: 12px; color: #666; }
          
          @media print {
            body { padding: 0; }
            .section-box { border: 2px solid #000 !important; -webkit-print-color-adjust: exact; }
          }
        </style>
      </head>
      <body>
        <div class="container">
          ${renderSection("Supplier Copy", data)}
          <div class="divider"></div>
          ${renderSection("Office Copy", data)}
        </div>
        <script>
          window.onload = function() { 
            setTimeout(() => {
              window.print(); 
              window.onafterprint = function() { window.close(); };
            }, 500); 
          };
        </script>
      </body>
    </html>
  `;

  function renderSection(label, d) {
    return `
      <div class="section-box">
        
        <table class="header-table">
          <tr>
            <td class="title-section">
              <img src="${Ijtimai}" alt="Logo" class="logo-img" />
              <h6>Supplier Payment Slip</h6>
            </td>
          </tr>
        </table>
             <div class="copy-label">${label}</div>

        <table class="info-table">
          <tr>
            <td class="label">Name:</td><td class="value">${d.supp_name || "________"}</td>
            <td class="label">Receipt No:</td><td class="value"><strong>#${d.pay_id || "________"}</strong></td>
          </tr>
          <tr>
            <td class="label">CNIC:</td><td class="value">${d.cnic || "________"}</td>
            <td class="label">Contact:</td><td class="value">${d.contact || "________"}</td>
          </tr>
          <tr>
            <td class="label">Animal Type:</td><td class="value">${d.category_name || "________"}</td>
            <td class="label">Category:</td><td class="value">${d.sub_category_name || "________"}</td>
          </tr>
          <tr>
            <td class="label">Total Paid:</td><td class="value">Rs. ${d.total_paid || "0"}</td>
            <td class="label">Deposit:</td><td class="value">Rs. ${d.deposit || "0"}</td>
          </tr>
          <tr>
            <td class="label">Amount Paid:</td><td class="value" style="color: green;">Rs. ${d.pay_amount || "0"}</td>
          </tr>
          <tr>
            <td class="label">Date:</td><td colspan="3" class="value">${new Date().toLocaleDateString('en-GB')}</td>
          </tr>
         
        </table>
        
        <div style="margin-top: 50px; display: flex; justify-content: space-between; font-size: 12px;">
          <span>Receiver Signature: __________________</span>
          <span>Authorized Signature: __________________</span>
        </div>
      </div>
    `;
  }

  printWindow.document.write(htmlContent);
  printWindow.document.close();
}